/**
 * URL search parameter key used to control the visibility of the downloads drawer.
 * When present in the URL, it toggles the drawer open/closed.
 * This allows for easier toggling of the drawer via URL.
 */
export const DRAWER_SEARCH_PARAM = 'show-downloads';
